// extracted by mini-css-extract-plugin
export default {"default":"HDfFaZ9jptqp5Ytxlr7L"};